"use strict";

module.exports = require("./Zoom.js");